import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';

const PostHogWrapper = ({ children }) => {
  const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
  const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
  const options = {
    api_host: posthogHost,
  };

  const shouldUsePostHog = posthogKey && posthogHost;

  if (shouldUsePostHog) {
    posthog.init(posthogKey, { api_host: posthogHost });
  }

  return shouldUsePostHog ? (
    <PostHogProvider apiKey={posthogKey} options={options}>
      {children}
    </PostHogProvider>
  ) : (
    <>{children}</>
  );
};

export default PostHogWrapper;
